import React, { useCallback, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useSwipeable } from "react-swipeable";
import { loginDTO, signInPasswordlessEndDTO } from "../../redux/auth";
import { IAppState } from "../../redux/types";
import { Dispatcher } from "../../service/RootDispather";
import { usePrevious } from "../../utils/hooks/hooks";
import { defaultLang } from "../../utils/Languages";
import { validate } from "../../utils/links";
import { Preloader } from "../preloader/Preloaders";
import { PhoneInput, CountrySelector } from "react-international-phone";

import "react-international-phone/style.css";
import "./styles.scss";
enum startPage_states {
  choose_method,
  enterLogin,
  inputLogin,
  wrongLogin,
  enterPass,
  inputPass,
  wrongPass,
  suspend,
}
const enum METHOD {
  Phone,
  Email,
}
const SignIn = (): JSX.Element => {
  const { t } = useTranslation("common");

  const { isLoading, isAuthenticated, signIn, isPasswordLess } = useSelector(
    (state: IAppState) => state.auth
  );
  const { local: language } = defaultLang;
  const isLoadingPrev = usePrevious(isLoading);
  const [errorPassword, seterrorPassword] = useState("");
  const isMobile = true;
  const rootDispatcher = Dispatcher();
  const [email, setemail] = useState("");
  const [previewPhone, setPreviewPhone] = useState("");
  const [errorEmail, seterrorEmail] = useState("");
  const [password, setpassword] = useState("");
  const [method, setMethod] = useState(undefined);
  const [pageState, setpageState] = useState(startPage_states.choose_method);
  const [country, setCountry] = useState("");
  const handlers = useSwipeable({
    onSwipedRight: () => onPrevStep(),
  });
  const [shouldDisplayPreloader, setshouldDisplayPreloader] = useState(false); //during correct email/pass check
  const phoneInputRef = useRef<any>(null);

  useEffect(() => {
    if (errorPassword !== "")
      seterrorPassword(
        isPasswordLess ? t("state.notcorrectCode") : t("state.wrongPass")
      );
    if (errorEmail !== "")
      seterrorEmail(
        isPasswordLess ? t("state.notcorrectPhone") : t("state.notcorrectEmail")
      );
  }, [language, errorPassword, errorEmail, isPasswordLess, t]);

  useEffect(() => {
    if (isLoadingPrev === true && isLoading === false) {
      setshouldDisplayPreloader(false);
      if (isAuthenticated === false) {
        setpageState(startPage_states.wrongPass);
        seterrorPassword(
          isPasswordLess ? t("state.notcorrectCode") : t("state.wrongPass")
        );
      }
    }
  }, [isLoading, isLoadingPrev, isAuthenticated, isPasswordLess, method, t]);

  useEffect(() => {
    if (signIn?.isLoading === false) {
      setshouldDisplayPreloader(false);
      if (signIn?.result === true) {
        if (method === METHOD.Phone) {
          rootDispatcher.signInPasswordless({ phoneNumber: email });
        }
        setpageState(startPage_states.enterPass);
      } else {
        if (signIn?.isBlocked && signIn?.isBlocked === true) {
          setpageState(startPage_states.suspend);
          seterrorPassword("");
          setemail("");
          setpassword("");
          rootDispatcher.signInCheckClear();
        } else {
          setpageState(startPage_states.wrongLogin);
          seterrorEmail(
            method === METHOD.Phone
              ? t("state.notcorrectPhone")
              : t("state.notcorrectEmail")
          );
        }
      }
      rootDispatcher.signInCheckClear();
    }
  }, [signIn, email, rootDispatcher, method, t]);

  const onNextClick = useCallback(
    (e) => {
      e.preventDefault();
      switch (pageState) {
        case startPage_states.enterLogin:
          setpageState(startPage_states.inputLogin);
          break;
        case startPage_states.inputLogin:
          if (method === METHOD.Email) {
            if (email.replace(/ /g, "") === "" || !validate(email)) {
              setpageState(startPage_states.wrongLogin);
              seterrorEmail(t("state.notcorrectEmail"));
              return false;
            }
            rootDispatcher.signInCheck(email);
            setshouldDisplayPreloader(true);
          } else {
            if (email.replace(/ /g, "") === "") {
              setpageState(startPage_states.wrongLogin);
              seterrorEmail(t("state.notcorrectPhone"));
              return false;
            }
            rootDispatcher.signInCheck(email);
            setshouldDisplayPreloader(true);
          }
          break;
        case startPage_states.enterPass:
          setpageState(startPage_states.inputPass);
          break;
        case startPage_states.inputPass:
          if (method === METHOD.Email) {
            if (password.replace(/ /g, "") === "") {
              seterrorPassword(t("state.wrongPass"));
              return false;
            }
            const dto: loginDTO = { username: email, password: password };
            rootDispatcher.signIn(dto);
            setshouldDisplayPreloader(true);
          } else {
            if (password.replace(/ /g, "") === "") {
              seterrorPassword(t("state.notcorrectCode"));
              return false;
            }
            const dto: signInPasswordlessEndDTO = {
              phoneNumber: email,
              verificationCode: password,
            };
            rootDispatcher.signInPasswordlessFinish(dto);
            setshouldDisplayPreloader(true);
          }
          break;
      }
    },
    [pageState, password, email, rootDispatcher, method, t]
  );

  useEffect(() => {
    const getCounty = () => {
      fetch("https://ipapi.co/json/") //'https://api.ipregistry.co/?key=tryout')
        .then(function (response) {
          return response.json();
        })
        .then(function (payload) {
          if (country === "") {
            console.log(payload);
            setPreviewPhone(payload.country_calling_code);
            setCountry(payload.country.toLowerCase());
          }
        });
    };
    getCounty();
  }, []);
  const onPrevStep = useCallback(() => {
    switch (pageState) {
      case startPage_states.enterLogin:
        setpageState(startPage_states.choose_method);
        break;
      case startPage_states.inputLogin:
        setpageState(startPage_states.enterLogin);
        break;
      case startPage_states.wrongLogin:
        setpageState(startPage_states.inputLogin);
        break;
      case startPage_states.enterPass:
        setpageState(startPage_states.inputLogin);
        break;
      case startPage_states.inputPass:
        setpageState(startPage_states.enterPass);
        break;
      case startPage_states.wrongPass:
        setpageState(startPage_states.inputPass);
        break;
      case startPage_states.suspend:
        setpageState(startPage_states.choose_method);
        break;
    }
  }, [pageState]);
  const [visibility, setVisibility] = useState(false);

  const visibilityPassword = () => {
    setVisibility(!visibility);
  };

  useEffect(() => {
    if (method === METHOD.Phone && email === "") {
      setemail(previewPhone);
    }
    if (phoneInputRef.current?.state?.country) {
      setCountry(phoneInputRef.current?.state?.country.iso2);
      setPreviewPhone(phoneInputRef.current?.state?.country.dialCode);
    }
    const handleKeyPress = (e) => {
      const key = e.keyCode || e.which;
      if (key === 13) {
        onNextClick(e);
      }
    };
    document.addEventListener("keypress", handleKeyPress);
    console.log(email);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [pageState, password, email, onNextClick, previewPhone]);

  const goToPhoneFlow = useCallback(() => {
    setpageState(startPage_states.enterLogin);
    setMethod(METHOD.Phone);
    setemail("");
    seterrorEmail("");
    rootDispatcher.signInSwitchToPhone();
  }, [rootDispatcher]);

  const goToEmailFlow = useCallback(() => {
    setpageState(startPage_states.enterLogin);
    setMethod(METHOD.Email);
    setemail("");
    seterrorEmail("");
    rootDispatcher.signInSwitchToEmail();
  }, [rootDispatcher]);
  return shouldDisplayPreloader ? (
    <Preloader />
  ) : (
    <div
      className={`preloader-page sign-up ${
        pageState === startPage_states.inputLogin ||
        pageState === startPage_states.inputPass
          ? "input"
          : ""
      }`}
      {...handlers}
    >
      <div className={`form-like ${isMobile ? "mobile-view" : ""}`}>
        <form onSubmit={onNextClick}>
          {pageState === startPage_states.choose_method && (
            <>
              {/* <b>{t("labels.signIn")}</b> */}
              <div className="sign-in-tabs">
                <button
                  onClick={goToEmailFlow}
                  type="button"
                  className={`btn btn-icon  sign-in email `}
                >
                  <i className="icon-email" />
                </button>
                <button
                  onClick={goToPhoneFlow}
                  type="button"
                  className={`btn btn-icon primary sign-in phone `}
                >
                  <i className="icon-phone" />
                </button>
              </div>
            </>
          )}
          {pageState === startPage_states.enterLogin && (
            <div className="flex-gap flex-gap-8 flex-center flex-direction">
              <p>
                {method === METHOD.Email ? (
                  // t("labels.stillEmailTitle")
                  ""
                ) : (
                  <div className="flex-direction-row display-flex align-items-center">
                    <CountrySelector
                      selectedCountry={country === "" ? "il" : country}
                      onSelect={({ iso2, dialCode }) => {
                        setCountry(iso2);
                        setemail(dialCode);
                        setPreviewPhone("+" + dialCode);
                      }}
                    />
                    <p>{previewPhone !== "" ? previewPhone : "+972"}</p>
                  </div>
                )}
              </p>
              <button
                className="btn btn-icon primary edit-sign-in"
                onClick={onNextClick}
                style={{ marginTop: "10px" }}
              >
                <i className="icon-edit"></i>
              </button>
            </div>
          )}
          {pageState === startPage_states.inputLogin && (
            <>
              {method === METHOD.Email ? (
                <div className="form-control add-control">
                  <div className={`input-wrap `}>
                    <input
                      type="email"
                      name="username"
                      id="username"
                      autoSave="true"
                      autoComplete="username"
                      inputMode="email"
                      autoCapitalize="none"
                      spellCheck="false"
                      autoFocus
                      maxLength={64}
                      value={email}
                      onChange={(e) => {
                        seterrorEmail("");
                        setemail(e.target.value);
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="form-control add-control">
                  <div
                  // className={`input-wrap ${errorEmail !== "" ? "error" : ""}`}
                  >
                    {/* <PhoneInput
                      defaultCountry={country}
                      value={email}
                      name="phone"
                      onChange={(e: any) => {
                        console.log("3321321", e);
                        seterrorEmail("");
                        setemail(e);
                      }}
                      ref={phoneInputRef}
                    /> */}
                    <input
                      type="tel"
                      maxLength={16}
                      name="phone"
                      id="phone"
                      autoSave="true"
                      autoComplete="username"
                      pattern="^\+?[0-9]{10,15}$"
                      inputMode="tel"
                      autoCapitalize="none"
                      spellCheck="false"
                      autoFocus
                      value={email}
                      onChange={(e) => {
                        seterrorEmail("");
                        const digits = e.target.value.replace(/\D/g, "");
                        setemail(`+` + digits);
                      }}
                      // onChange={(e) => {
                      //   seterrorEmail("");
                      //   setemail(e.target.value.replace(/[^0-9+]/g, ""));
                      // }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {pageState === startPage_states.wrongLogin && (
            <div className="flex-column flex-column-24">
              {/* <p>{errorEmail}</p> */}
              <div className="flex-gap display-flex flex-center flex-column">
                <p
                  className="danger overflow-text text-size-14"
                  style={{ marginRight: "8px" }}
                >
                  {method === METHOD.Phone ? (
                    <div className="flex-direction-row display-flex align-items-center">
                      <CountrySelector
                        selectedCountry={country === "" ? "il" : country}
                        onSelect={({ iso2, dialCode }) => {
                          setCountry(iso2);
                          setemail(dialCode);
                          setPreviewPhone(dialCode);
                        }}
                      />
                      <p>{previewPhone !== "" ? email : "+972"}</p>
                    </div>
                  ) : (
                    email
                  )}
                </p>
                <button
                  className="btn btn-icon secondary edit-sign-in"
                  onClick={onPrevStep}
                >
                  <i className="icon-edit"></i>
                </button>
              </div>
            </div>
          )}
          {pageState === startPage_states.enterPass && (
            <div className="flex-column flex-column-24">
              <p className="overflow-text text-size-14">{email}</p>
              <div className="flex-gap flex-gap-8 flex-center">
                {/* <p style={{ marginRight: "8px" }}>
                  {method === METHOD.Phone
                    ? t("labels.code")
                    : t("labels.password")}
                </p> */}
                {/* <button
                  className="btn btn-icon"
                  style={{ background: "#48494B" }}
                  onClick={visibilityPassword}
                >
                  <i
                    className={`${visibility ? "icon-eye-on" : "icon-eye-no"}`}
                  ></i>
                </button> */}
                <button
                  className="btn btn-icon primary edit-sign-in"
                  onClick={onNextClick}
                >
                  <i className="icon-edit"></i>
                </button>
              </div>
            </div>
          )}
          {pageState === startPage_states.inputPass && (
            <>
              {method === METHOD.Email ? (
                <div className="form-control add-control">
                  <div
                    className={`input-wrap pwrd-input ${
                      errorPassword !== "" ? "error" : ""
                    }`}
                  >
                    <input
                      id="password"
                      type={visibility ? "text" : "password"}
                      autoComplete="current-password"
                      autoCapitalize="none"
                      spellCheck="false"
                      autoFocus
                      value={password}
                      onChange={(e) => {
                        setpassword(e.target.value);
                        seterrorPassword("");
                      }}
                      name="password"
                    />
                  </div>
                </div>
              ) : (
                <div className="form-control add-control">
                  <div
                    className={`input-wrap ${
                      errorPassword !== "" ? "error" : ""
                    }`}
                  >
                    <input
                      type={"number"}
                      autoCapitalize="none"
                      spellCheck="false"
                      autoFocus
                      maxLength={8}
                      placeholder={"X X X X X X"}
                      value={password}
                      name="passwordCode"
                      onChange={(e) => {
                        setpassword(e.target.value);
                        seterrorPassword("");
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {pageState === startPage_states.wrongPass && (
            <div className="flex-column flex-column-24">
              {/* <p>{errorPassword}</p> */}
              <div className="flex-gap flex-gap-8 flex-center">
                {visibility ? (
                  <p
                    className="danger overflow-text text-size-14"
                    style={{ marginRight: "8px" }}
                  >
                    {password}
                  </p>
                ) : (
                  <p
                    className="danger overflow-text text-size-14"
                    style={{ marginRight: "8px" }}
                  >
                    {method === METHOD.Email ? "*********" : password}
                  </p>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5px",
                }}
              >
                {method !== METHOD.Phone ? (
                  <button
                    className="btn btn-icon edit-sign-in"
                    style={{ background: "#48494B" }}
                    onClick={visibilityPassword}
                  >
                    <i
                      className={`${
                        visibility ? "icon-eye-on" : "icon-eye-no"
                      }`}
                    ></i>
                  </button>
                ) : (
                  ""
                )}
                <button
                  className="btn btn-icon secondary edit-sign-in"
                  onClick={onPrevStep}
                  style={{ marginLeft: method !== METHOD.Phone ? "10px" : "" }}
                >
                  <i className="icon-edit"></i>
                </button>
              </div>
            </div>
          )}
          {pageState === startPage_states.suspend && (
            <div className="flex-column flex-column-24">
              <div className="flex-column flex-column-8">
                <i className="icon-suspend" />
                <p>{t("labels.userBlock")}</p>
              </div>

              <button className="btn with-icon secondary" onClick={onPrevStep}>
                <i className="icon-people-out"></i>
                {t("buttons.SignOut")}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default React.memo(SignIn);
